import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './useAnalytics';

export function usePageTracker() {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;
    trackPageView(location.pathname);
  }, [location.pathname]);
}
